import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Clock } from "lucide-react";
import { iconFor } from "../lib/categoryIcons";

export default function JobCard({ job, catLabel, cardTestId, applyTestId }) {
  const Icon = iconFor(job.category);
  const fresh = (job.posted_days_ago || 1) <= 2;
  return (
    <article className="group rounded-2xl bg-white p-5 sm:p-6 ring-1 ring-[#0F2A1F]/10 flex flex-col hover:ring-[#0F2A1F]/30 hover:-translate-y-0.5 hover:shadow-[0_20px_50px_-30px_rgba(15,42,31,0.45)] transition-[transform,box-shadow] duration-300" data-testid={cardTestId}>
      <div className="flex items-start gap-3">
        <div className="h-11 w-11 shrink-0 rounded-xl bg-[#0F2A1F] text-[#D4AF37] flex items-center justify-center">
          <Icon className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5 flex-wrap text-[11px] font-semibold">
            <span className="rounded-full bg-[#10B981]/15 text-[#0d7a55] px-2 py-0.5">Remote</span>
            {catLabel && <span className="rounded-full bg-[#0F2A1F]/[0.06] text-[#0F2A1F]/70 px-2 py-0.5">{catLabel}</span>}
            {fresh && <span className="rounded-full bg-[#D4AF37]/20 text-[#7a5f12] px-2 py-0.5">New</span>}
          </div>
          <h3 className="mt-2 text-xl sm:text-2xl font-bold text-[#0F2A1F] leading-snug">{job.title}</h3>
        </div>
      </div>
      <div className="mt-4 text-lg font-semibold text-[#0F2A1F]">{job.salary_range}</div>
      <div className="mt-1.5 flex flex-wrap gap-x-4 gap-y-1 text-sm text-[#0F2A1F]/60">
        <span className="inline-flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" /> {job.location}</span>
        <span className="inline-flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" /> {job.experience}</span>
      </div>
      <p className="mt-3 text-sm text-[#0F2A1F]/65 leading-relaxed line-clamp-3 flex-1">{job.description}</p>
      <Link to={`/apply/${job.id}`} className="mt-5 h-12 inline-flex items-center justify-center gap-2 rounded-xl bg-[#0F2A1F] text-white text-sm font-semibold hover:bg-[#163b2c] transition-colors" data-testid={applyTestId}>
        Apply in 60 seconds <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
      </Link>
    </article>
  );
}
